import React from 'react';

import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import './date-picker.css';

export const DatePickerComponent = ({
	date,
	setDate,
	setIsChanged
}: {
	date: Date | null;
	setDate: (date: Date | null) => void;
	setIsChanged: (isChanged: boolean) => void;
}) => {
	return (
		<DatePicker
			className="inputStyle"
			selected={date}
			onChange={(date) => {
				setDate(date);
				setIsChanged(true);
			}}
			dateFormat="MMMM d, yyyy"
			fixedHeight
		/>
	);
};
